import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../../_models/user-name-display-result-dto';

export class TransactionLogResultDto {
    userAction: string;
    @Type(() => Date)
    updatedDate: Date;
    @Type(() => UserNameDisplayResultDto)
    updatedBy: UserNameDisplayResultDto;
    description: string;
    sequenceNumber: number;

    get updatedByDisplayText(): string {
        return Utils.notNullAndDefined(this.updatedBy) ? this.updatedBy.getDisplayName() : null;
    }
}
